import {
  type CommandProperties,
  createCommand,
} from '@atlassian/rovo-content-bridge-api';

/**
 * @see {@link SetCurrentViewCommand}
 */
export interface SetCurrentViewCommandProperties extends CommandProperties {
  viewId: string;
}

/**
 * Command to change the active view of the database in the native embed experience.
 *
 * This command allows the host application (Whiteboards/Confluence) to programmatically
 * switch between different database views (table, board, gallery, etc.), typically
 * triggered from the view switcher.
 */
export const SetCurrentViewCommand = createCommand<SetCurrentViewCommandProperties, void>(
  'set-current-view-command'
);
